<template>
  <div class="daizhifu2" style="height: calc(100vh - 208px);">
    <!-- <hear></hear> -->
      <div class="Guarantee_status_box">
        <div
          style="
              padding: 0 20px;
              display: flex;
              justify-content: space-between;
            
            "
        >
          <div style="display: flex">
            <el-button
              @click="shuaxin"
              type="info"
              icon="el-icon-refresh-right"
              class="anniu"
            ></el-button>
          </div>

          <div
            style="display: flex; justify-content: space-around;"
          >
            <el-row
              style="display: flex;
    justify-content: flex-end;"
              class="mb8"
            >
              <el-col :span="19" class="seach">
                <el-input
                clearable
                  v-model="params.merOrderId"
                  placeholder="请输入支付订单号"
                ></el-input>
                <el-button
                  type="primary"
                  icon="el-icon-search"
                  @click="sousuo"
                ></el-button>
              </el-col>
            </el-row>
          </div>
        </div>

        <div style=" flex: 1;" class="shenflex">
          <el-table
            v-loading="loading"
            element-loading-background="rgb(255 255 255 / 80%)"
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            class="table xtable"
            stripe
        border
        align="center"
        highlight-current-row
            @selection-change="handleSelectionChange"
          >
            <el-table-column align="center" type="selection" width="55">
            </el-table-column>
            <el-table-column
              align="center"
              prop="merOrderId"
              :show-overflow-tooltip="true"
              label="支付编号"
              width="300"
            >
            </el-table-column>

            <el-table-column
              align="center"
              prop="username"
              :show-overflow-tooltip="true"
              label="付款人"
              width="120"
            >
            </el-table-column>

            <el-table-column
              align="center"
              :show-overflow-tooltip="true"
              prop="zftype"
              width="120"
              label="付款类型"
            >
            </el-table-column>
            <el-table-column
              align="center"
              :show-overflow-tooltip="true"
              prop="guarantee_company_name"
              width="300"
              label="出函机构名称"
            >
            </el-table-column>
            <el-table-column
              align="center"
              :show-overflow-tooltip="true"
              prop="cp_name"
              width="260"
              label="产品名称"
            >
            </el-table-column>
            <el-table-column
              align="center"
              :show-overflow-tooltip="true"
              prop="bankname"
              width="120"
              label="银行"
            >
            </el-table-column>
            <el-table-column
              align="center"
              :show-overflow-tooltip="true"
              prop="bankcode"
              width="120"
              label="银行卡号"
            >
            </el-table-column>
            <el-table-column
              align="center"
              :show-overflow-tooltip="true"
              prop="bankaccount"
              width="220"
              label="银行账号"
            >
            </el-table-column>

            <el-table-column
              align="center"
              :show-overflow-tooltip="true"
              prop="state"
              width="220"
              label="支付状态"
            >
              <template slot-scope="scope">{{
                scope.row.state == 0 ? "未支付" : "支付"
              }}</template>
            </el-table-column>
            <el-table-column
              align="center"
              :show-overflow-tooltip="true"
              prop="createtime"
              width="220"
              label="添加时间"
            >
              <template slot-scope="scope">{{
                scope.row.createtime | dateFormat
              }}</template>
            </el-table-column>
            <el-table-column
              align="center"
              :show-overflow-tooltip="true"
              prop="beizhu"
              width="220"
              label="备注"
            >
            </el-table-column>

            <el-table-column
              fixed="right"
              align="center"
              width="110"
              label="操作"
            >
              <template slot-scope="scope">
                <el-button size="mini" @click="handlesc(scope.row)"
                  >去支付</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <el-dialog
        title="添加步骤"
        :visible.sync="opens"
        width="700px"
        append-to-body
      >
        <el-form ref="form" :model="form" :rules="rules" label-width="80px">
          <div style="display: flex; justify-content: center; margin-top: 20px">
            <div>
              <el-form-item label="操作名称">
                <el-input v-model="form.operation"></el-input>
              </el-form-item>
              <el-form-item label="审核等级">
                <el-input v-model="form.dengji"></el-input>
              </el-form-item>
            </div>
          </div>
          <div style="display: flex; justify-content: center">
            <el-button style="margin: 0px" type="primary">确定</el-button>
          </div>
        </el-form>
      </el-dialog>
      <el-dialog
        title="添加流程"
        :visible.sync="open"
        width="400px"
        append-to-body
      >
        <el-form ref="form" :model="form" label-width="80px" :rules="rules">
          <el-form-item label="流程名称">
            <el-input v-model="liuch.lc_name"></el-input>
          </el-form-item>
          <div
            style="display: flex; justify-content: center; margin-top: 20px"
          ></div>
        </el-form>
      </el-dialog>
      <div class="block">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentpage"
          :page-sizes="[10, 20, 30]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="limit"
        ></el-pagination>
      </div>

  </div>
</template>

<script>
import { paylist } from "@/api/system/liucheng";
// import hear from ".././../components/hear.vue";
import axios from "axios";
export default {
  components: {
    // hear
  },
  name: "progress2",
  data() {
    return {
      total: null,
      currentpage: null,

      BidingDocumentList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      opens: false,
      params: {
        offset: 0,
        // limit : 10,
        state: 0,
        keywords: ""
        // user_id: sessionStorage.getItem("id"),
      },
      total: null,
      limit: null,
      // 表单参数
      form: {
        name1: "",
        name2: "",
        name3: "",
        dept: "",
        user_id: "",
        lc_id: "",
        bm_id: "",
        bm_name: "",
        staff_id: "",
        staff_name: "",
        operation: "",
        dengji: ""
      },
      // 表单校验
      rules: {},
      options1: [], //选择部门
      options2: [], //选择职位
      btype: [],
      options3: [], //选择小组
      options4: [], //选择小组
      currentPage1: 5,
      currentPage2: 5,
      currentPage3: 5,
      currentPage4: 4,
      tableData: [],
      multipleSelection: [],
      liuch: {
        user_id: sessionStorage.getItem("id"),
        lc_name: "",
        gtype: ""
      },
      buzhl: false,
      buzhilist: [],
      loading: true
    };
  },
  mounted() {
    // this.getBhlist();
    this.zhifu();
  },
  methods: {
    sousuo() {
      this.shuaxin()
    },
    handleUpdate(e) {
      this.opens = true;
    },
    handlesc(e) {
      sessionStorage.setItem("apply_number", e.apply_number);
      this.$router.push("/Bidpayments");
    },
    buzhlist(e) {
      this.buzhl = true;
    },
    zhifu() {
      paylist(this.params).then(res => {
        // console.log("发票列表", res);
        if (res.data.code == 1) {
          this.limit = res.data.data.total;
          this.tableData = res.data.data.rows;
          this.loading = false;
        } else {
          console.log("失败", err.response.data);
          this.$notify.error({
            message: err.response.data.msg
          });
        }
      });
    },
    shuaxin() {
      this.loading = true;
      var that = this;
      setTimeout(function() {
        that.zhifu();
      }, 500);
    },
    getBhlist() {
      paylist(this.params).then(res => {
        this.BidingDocumentList = res.data.data.rows;
        this.total = res.data.data.total;
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.params.limit = val;
      this.zhifu();
    },
    handleCurrentChange(val) {
      this.params.offset = parseInt(val - 1);
      this.currentpage = val;
      this.zhifu();
    }
  }
};
</script>

<style scoped>
.daizhifu2{
      display: flex;
    flex-direction: column;
    overflow: auto;
}
html body {
  height: 100% !important;
  /* background-color: #f5f6fa !important; */
}
.block {
  padding: 10px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.state_bh {
  font-size: 18px;
  font-family: Microsoft YaHei-Regular, Microsoft YaHei;
  font-weight: 400;
  color: #1890ff;
  width: 143px;
  height: 47px;
  border-radius: 4px 4px 4px 4px;
  opacity: 1;
  line-height: 47px;
  text-align: center;
  border: 2px solid #1890ff;
}
.shenflex {
 
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  padding-top: 10px;
}
.status_bg1 {
  width: 85px;
  height: 40px;
  background-color: #ff1818;
  border-bottom-left-radius: 10px;
  position: relative;
  bottom: 87%;
  left: 94%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-size: 18px;
}

.status_bg {
  width: 85px;
  height: 40px;
  background-color: #1795ff;
  border-bottom-left-radius: 10px;
  position: relative;
  bottom: 87%;
  left: 94%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-size: 18px;
}

.examine_btn {
  width: 143px;
  height: 47px;
  color: #1795ff;
}

.bubble {
  color: #ffffff;
  font-size: 12px;
  width: 94px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 31px;
  margin-left: 20px;
  background-image: url("../../assets/Guarantee/Bubble.png");
}

.Guarantee_details {
  justify-content: space-around;
}

.Ge_box {
  width: 113px;
  height: 33px;
  border-radius: 4px;
  background-color: #1795ff;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  margin-left: 15px;
}

.Guarantee_num {
  width: 219px;
  height: 48px;
  color: #333333;
}

.Guarantee_status_box {
  flex: 1;
      display: flex;
    flex-direction: column;
  /* position: relative;
  top: 9%;
  left: 247px; */
}

.Guarantee_status {
  width: 95%;
  height: 162px;
  margin-bottom: 20px;
  background-color: #ffffff;
  box-shadow: 0px 0px 6px 1px rgba(0, 0, 0, 0.16);
}

.Guarantee_examine {
  color: #333333;
  font-size: 24px;
  margin-left: 30px;
  margin-top: 10px;
  font-weight: Bold;
  margin-bottom: 36px;
}

::v-deep .el-table__body-wrapper {
  height: 69vh !important;
  /* margin-top: 10px; */
  overflow: auto !important;
}
</style>
<style scoped></style>



// WEBPACK FOOTER //
// src/view/Guarantee/zhifu.vue